import { createContext } from 'react';
export const FileSystemContext = createContext({
    fileSystemData: undefined,
    loading: false,
    error: undefined,
    folderId: undefined,
});
